import { msg, str } from '@lit/localize';

type Params = Record<string, unknown> | undefined;
type Renderer = (p?: Params) => string;

/**
 * Mappt stabile Backend-Fehlercodes auf lokalisierbare Texte.
 * Jeder Eintrag enthält ein msg(...) mit einem *Literal* -> wird von lit-localize extrahiert
 */
export const ERROR_TEXTS: Record<string, Renderer> = {
  WRONG_CREDENTIALS: () => msg('User/Password Combination does not exist'),
  TOKEN_INVALID: () => msg('Token is invalid'),
  TOKEN_INVALID_OR_EXPIRED: () => msg('Token is invalid or Expired'),
  IF_POSSIBLE_WE_SEND_EMAIL: (p) => msg(str`If the email ${String(p?.email ?? '')} is usable we sent you a message.`),
  //Beispiel mit Parametern
  EMAIL_ALREADY_USED: (p) => msg(str`The email ${String(p?.email ?? '')} is not registerable.`),
  PATH_TRAVERSAL_ATTEMPT: () => msg('Path traversal attempt detected'),
  INVALID_LOCALE: () => msg('Invalid locale'),
  UNSUPPORTED_FILE_TYPE: () => msg('Unsupported file type'),
  INVALID_TOKEN_PATH: () => msg('Invalid token path'),
  AVATAR_INVALID_OWNER_ID: () => msg('Owner ID is invalid'),
  PERMISSION_DENIED: () => msg('You do not have permission to perform this action'),
  FAMILY_NOT_FOUND: () => msg('Family was not found'),
  FAMILY_MEMBERSHIP_NOT_FOUND: () => msg('Family membership was not found'),
  FAMILY_MEMBER_NOT_ACTIVE: () => msg('This family member is not active'),
  FAMILY_MEMBER_HAS_ACTIVE_TASKS: (p) =>
    msg(str`This family member still has ${String(p?.active_tasks_count ?? 0)} active tasks.`),
  FAMILY_MEMBER_IS_LAST_ADMIN_OR_PARENT: () =>
    msg('This family member cannot be removed because no responsible adult would remain'),
  TASK_NOT_DELETED: () => msg('Task could not be deleted'),
  TASK_NOT_COMPLETED: () => msg('Task could not be completed'),
  TASK_NOT_INCOMPLETED: () => msg('Task could not be marked as incomplete'),
  TASK_NOT_SUBMITTED: () => msg('Task could not be submitted'),
  TASK_NOT_APPROVED: () => msg('Task could not be approved'),
  TASK_NOT_FOUND: () => msg('Task was not found'),
  TASK_NOT_REJECTED: () => msg('Task could not be rejected'),
  NO_TRANSACTION_CREATED: () => msg('Transaction could not be created'),
};

/**
 * Übersetzt (code, params) -> string. Fallbacks: messageFallback -> generischer Text
 */
export function translateErrorCode(code?: string | null, params?: Params, messageFallback?: string): string {
  const normalize = (s: string) => s.trim().toUpperCase();

  if (code) {
    const normalizedCode = normalize(code);
    if (ERROR_TEXTS[normalizedCode]) {
      return ERROR_TEXTS[normalizedCode](params);
    }
  }

  if (messageFallback) {
    const normalizedFallback = normalize(messageFallback);
    if (ERROR_TEXTS[normalizedFallback]) {
      return ERROR_TEXTS[normalizedFallback](params);
    }
    if (messageFallback !== code) {
      return messageFallback;
    }
  }

  return msg('An unknown error occurred.');
}
